import { useCallback } from 'react'
import { useSourcePluginContext } from '../../context/SourcePluginContext'
import useAppointmentNotes from '../../hooks/useAppointmentNotes'
import { useNoteAmendmentsEnabled } from '../../hooks/useNoteAmendmentsEnabled'
import useMember from '../../hooks/useMember'
import { Appointment, AppointmentNote } from '../../types/types'
import { formatName } from '../../utils/provider.utils'
import { formatMMDDYYYY } from '../../utils/time.utils'
import './styles.scss'
interface PostAppointmentNoteTableRowProps {
  appointment: Appointment
  viewNote: (note: AppointmentNote, appointment: Appointment) => void
  editNote: (note: AppointmentNote, appointment: Appointment) => void
  createNew: (appointment: Appointment) => void
}

const PostAppointmentNoteTableRow: React.FC<
  PostAppointmentNoteTableRowProps
> = ({ appointment, createNew, editNote, viewNote }) => {
  const { pluginContext } = useSourcePluginContext()
  const amendmentsEnabled = useNoteAmendmentsEnabled()
  const { member } = useMember(pluginContext?.member ?? undefined)
  const { notes } = useAppointmentNotes(pluginContext?.member ?? undefined)

  const note = notes.find((n) => n.appointment.id === appointment.id)

  const handleViewNote = useCallback(
    () => viewNote(note!, appointment), // eslint-disable-line
    [note, appointment]
  )

  const handleEditNote = useCallback(
    () => editNote(note!, appointment), // eslint-disable-line
    [note, appointment]
  )

  const handleCreateNote = useCallback(
    () => createNew(appointment),
    [appointment]
  )

  return (
    <div className="d-flex justify-content-evenly align-items-center">
      <p className="appointment-notes-table-cell text mb-0">
        {formatName(appointment.provider)}
      </p>
      <p className="appointment-notes-table-cell-small text mb-0">
        {appointment.type.category}
      </p>
      <p className="appointment-notes-table-cell-small text mb-0">
        {formatMMDDYYYY(new Date(appointment.time))}
      </p>
      <div className="row-actions d-flex justify-content-end align-items-center gap-2">
        {!!note?.addenda?.length && (
          <span className="edited-indicator">Edited</span>
        )}
        {note && (
          <button className="row-action" onClick={handleViewNote} type="button">
            View note {note.status !== 'signed' ? `(${note.status})` : ''}
          </button>
        )}
        {note?.status === 'signed' && amendmentsEnabled && (
          <button className="row-action" onClick={handleEditNote} type="button">
            Edit note
          </button>
        )}
        {!note && member !== undefined && (
          <button
            className="row-action"
            onClick={handleCreateNote}
            type="button"
          >
            Create note
          </button>
        )}
      </div>
    </div>
  )
}

export default PostAppointmentNoteTableRow
